module.exports = __webpack_public_path__ + "img/1440.c1ff4868.jpg";